import { render, staticRenderFns } from "./ISettings.vue?vue&type=template&id=370a817e&"
import script from "./ISettings.vue?vue&type=script&lang=ts&"
export * from "./ISettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports